import Grid from "@mui/material/Grid";

import type { ReactNode } from "react";
import type { Theme } from "@mui/material/styles";

import MDBox from "@vendor/components/MDBox";
import PageLayout from "@vendor/examples/LayoutContainers/PageLayout";

// Layout base de las pantallas públicas (login, charge-hour, confirmación de
// factura pública). Lo consumen varios módulos, así que vive en shared/ui en
// lugar de en un módulo concreto.
export interface BasicLayoutProps {
  image: string;
  children: ReactNode;
}

export const BasicLayout = ({ image, children }: BasicLayoutProps) => {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }: Theme) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid
          container
          spacing={1}
          sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}
        >
          <Grid
            size={{
              xs: 11,
              sm: 9,
              md: 5,
              lg: 4,
              xl: 3,
            }}
          >
            {children}
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
};
